module.exports = __webpack_public_path__ + "img/cart.699620a9.svg";